module.exports = __webpack_public_path__ + "img/doctor-avatar.94e9add2.png";